module.exports = __webpack_public_path__ + "img/galleria-original-960.435d4d19.png";